// Coordinator — the Triage section's cinematic live stage for the Signal
// Orchestrator's dedup/coordination loop (DEV-16319), a sidebar sibling
// of Inbox and Board. Moved here from `/orchestrator/live` in the 2026-07
// nav review (the old URL redirects). "Watch the system think": open
// signals, run pills, HITL pauses, and the animated dedup wires.
//
// The route is full-bleed (registered in __root.tsx); the layout is a
// flex column with a slim dark band up top (admin links out to the
// Orchestrator's Settings/Analytics pages) + LiveStage (flex: 1) taking
// the remaining viewport space. `.olv-fit`'s flex/min-height: 0 means
// the stage rescales into whatever height it gets.
import { Link, createFileRoute } from '@tanstack/react-router';
import { type CSSProperties } from 'react';

import { PageHeader } from '../../components/common/PageHeader';
import { LiveStage } from '../../components/orchestrator/live-stage/LiveStage';
import { routes } from '../../lib/constants';

const wrapperStyle: CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  minHeight: 0,
  width: '100%',
};

// Full-width dark band so the cinematic backdrop continues edge-to-edge
// behind the admin links.
const bandStyle: CSSProperties = {
  background: 'var(--bg-chrome, #0c0c0c)',
  width: '100%',
  flexShrink: 0,
  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'center',
  gap: 'var(--sp-2)',
  padding: 'var(--sp-1) var(--sp-7)',
};

const settingsLinkStyle: CSSProperties = {
  color: 'var(--text-secondary)',
  textDecoration: 'none',
  fontSize: 'var(--fs-xs)',
  padding: 'var(--sp-1) var(--sp-2)',
};

function CoordinatorRoute() {
  return (
    <div style={wrapperStyle}>
      <PageHeader title="Coordinator" />
      <div style={bandStyle}>
        <Link to={routes.ORCHESTRATOR} style={settingsLinkStyle}>
          Coordinator settings
        </Link>
        <Link to={routes.ORCHESTRATOR_ANALYTICS} style={settingsLinkStyle}>
          Analytics
        </Link>
      </div>
      <LiveStage />
    </div>
  );
}

export const Route = createFileRoute('/inbox/coordinator')({ component: CoordinatorRoute });
